// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1oV7X","info":"UpdateTermsInfo_info__K7ajW"};